export default {
  setCalendar(state, calendar) {
    state.calendar = calendar;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
  }
};
